import { Component, OnDestroy } from '@angular/core';
import { NavController, AlertController, ToastController, ActionSheetController, ModalController, LoadingController, Platform } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { provider } from '../../providers/provider';
import { Http } from '@angular/http';
import { Subject } from 'rxjs';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';

import { CustomerPage } from '../account/customer/customer';
import { SelectShopPage } from '../selectshop/selectshop';
import { MenuPage } from '../menu/menu';
import { CustomizerProvider } from '../../providers/customizer/customizer';
import { Deeplinks } from '@ionic-native/deeplinks';
import { Success } from '../success/success';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage implements OnDestroy {
  barcodePrompt = '<ion-content scrollable="false"><img class="center" src="assets/scanqr.png"></ion-content>';
  token: any;
  version: String = '';
  customerInfo = {};
  private _onDestroy = new Subject();
  selectedLocale = false;
  options: InAppBrowserOptions = {
    hardwareback: 'yes',
    toolbar: 'yes'
  };

  constructor(
    public http: Http,
    public navCtrl: NavController,
    public storage: Storage,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public barcodeScanner: BarcodeScanner,
    public provider: provider,
    public modalCtrl: ModalController,
    public translateService: TranslateService,
    public loadingCtrl: LoadingController,
    public actionSheetCtrl: ActionSheetController,
    public customizer: CustomizerProvider,
    public platform: Platform,
    private deeplinks: Deeplinks,
    private iab: InAppBrowser) {

    storage.ready().then(() => {
      // storage is ready
      // get cities
      this.provider.getCities();

      this.selectedLocale = provider.getSelectedLocale();

      storage.get('customer').then((customer) => {
        this.customerInfo = JSON.parse(customer);
      });

      storage.get('codSfogliaMenu').then((cod) => {
        if (cod) {
          this.token = cod;
          this.provider.setTable(this.token);
          this.navCtrl.push(MenuPage);
        }
      });

      storage.get('versione').then((value) => {
        if (value) {
          if (value.ios) this.version = "ver. " + value.ios.str
          else if (value.android) this.version = "ver. " + value.android.str
          else this.version = ''
        } else {
          this.version = ''
        }
      })
    });

    platform.ready().then(() => {
      this.deeplinks.routeWithNavController(this.navCtrl,{
        '/positive': Success,
        '/negative': {},
      }).subscribe(
        match => {
          //Successfully matched route

          let toast = this.toastCtrl.create({
            message: match.$link.path === '/positive' ? 'Pagamento effettuato' : 'Pagamento Rifiutato',
            duration: 3000
          });
          toast.present();
        },
        noMatch => {
          //no matched route
        }
      )
    })
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  select(locale) {
    if (locale == 'asporto') {
      this.provider.setTable(this.customizer.takeAwayToken());
      this.navCtrl.push(MenuPage);
    } else if(locale == 'wine') {
      this.iab.create('https://lk.tapmenu.it/favalli-enoweb', '_system', this.options);
    } else if(locale == 'sitoweb') {
      this.iab.create(this.customizer.getSitoWeb().toString(), '_system', this.options);
    } else if(locale == 'instagram') {
      this.iab.create(this.customizer.getInstagram().toString(), '_system', this.options);
    } else if(locale == 'facebook') {
      this.iab.create(this.customizer.getFacebook().toString(), '_system', this.options);
    } else if(locale == 'home') {
      this.provider.setSelectedLocale(false);
      this.provider.clearApp();
      location.reload();    
    } else {
      let shop = locale + '.json';
      this.provider.setSelectedLocale(true);
      this.customizer.loadCustomization(shop);
      this.navCtrl.push(HomePage);
    }
  }

  showAlert(message) {
    this.translateService.get('ERRORE').takeUntil(this._onDestroy).subscribe(msg => {
      let alert = this.alertCtrl.create({
        title: msg.ERRORE,
        message: message,
        buttons: [
          {
            text: 'OK', role: 'cancel', handler: () => {
              location.reload();
            }
          }
        ]
      });
      alert.present();
    });
  }

  processBarcodeReading(barcode: String, message: String) {
    this.provider.clearApp();
    if (barcode.startsWith("http")) {
      if (barcode === 'https://q2w.it/tap-menu' || barcode === 'http://q2w.it/tap-menu') {
        // it's the app qr code
        this.showAlert(message);
      }
      else if (barcode.startsWith('http://q2w.it') || barcode.startsWith('https://q2w.it')) {
        // valid table
        this.provider.getTable(barcode).then(data => {
          this.provider.setTable(data["_body"]);
          this.navCtrl.push(MenuPage);
        });
      }
      else {
        // the url it not mine
        this.showAlert(message);
      }
    }
    else if (barcode != null && barcode.length > 0) {
      this.provider.setTable(barcode);
      this.navCtrl.push(MenuPage);
    }
  }

  goTo(choice) {
    if (choice == 'selforder') {
      if (this.customizer.selfOrderingToken() != null) {
        this.provider.setTable(this.customizer.selfOrderingToken());
        this.navCtrl.push(MenuPage);
      }
      else {
        this.alertQR();
      }
    } else {
      this.provider.setSfogliamenu();
      if (this.customizer.readingMenuToken() != null) {
        this.provider.setTable(this.customizer.readingMenuToken());
        this.navCtrl.push(MenuPage);
      }
      else {
        this.alertQR();
      }
    }
  }

  alertQR() {
    this.translateService.get(['ALERTITLE', 'QR_ERRATO', 'QR_MANUAL_TITLE',
      'QR_CANT_READ', 'QR_INSERT_MANUAL', 'PROCEED',
      'ANNULLA']).takeUntil(this._onDestroy).takeUntil(this._onDestroy).subscribe(msg => {
        let alert = this.alertCtrl.create({
          title: msg.ALERTITLE,
          message: this.barcodePrompt,
          buttons: [
            {
              text: 'OK',
              role: 'cancel',
              handler: () => {
                this.barcodeScanner.scan().then((result) => {
                  this.processBarcodeReading(result.text, msg.QR_ERRATO);
                }).catch((error) => {
                  //inserimento manuale
                  const prompt = this.alertCtrl.create({
                    title: msg.QR_MANUAL_TITLE,
                    message: msg.QR_CANT_READ,
                    inputs: [
                      {
                        name: 'text',
                        placeholder: msg.QR_INSERT_MANUAL
                      },
                    ],
                    buttons: [
                      { text: msg.ANNULLA },
                      {
                        text: msg.PROCEED,
                        handler: result => {
                          this.processBarcodeReading(result.text, msg.QR_ERRATO);
                        }
                      }
                    ]
                  });
                  prompt.present();
                });
              }
            }]
        });
        alert.present();
      });
  }

  asporto() {
    // handle customization
    if (this.customizer.takeAwayToken() != null) {
      this.provider.setTable(this.customizer.takeAwayToken());
      this.navCtrl.push(MenuPage);
    }
    else {
      // normal application flow
      let loading = this.loadingCtrl.create({
        content: '<ion-spinner name="circles"></ion-spinner>'
      });
      let modal = this.modalCtrl.create(SelectShopPage);
      modal.onDidDismiss(data => {
        if (data != undefined) {
          this.provider.getJWTAsporto(data).takeUntil(this._onDestroy).subscribe(jwt => {
            loading.present().then(() => {
              this.provider.setTable((<any>jwt)._body);
              loading.dismiss().then(() => {
                this.navCtrl.push(MenuPage);
              });
            })
          }, err => {
            console.log(err);
          });
        }
      });
      modal.present();
    }
  }

  customer() {
    this.navCtrl.push(CustomerPage);
  }

  ionViewDidLoad() {
    if (document.URL.indexOf("?") > 0) {
      const splitURL = document.URL.split("?");
      const urlData = JSON.parse(window.atob(splitURL[1]));
      this.provider.setTable(urlData.tableJwt);
      this.provider.setTemporaryCustomer(urlData.customerData);

      this.navCtrl.push(MenuPage);
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts